<template>
  <div
    v-if="config"
    class="mastery-panel"
  >
    <div class="content">
      <div class="title">
        {{ config.title }}
      </div>
      <div
        class="text"
        v-html="config.text"
      />
    </div>
    <button
      v-if="config.cta"
      class="call-to-action"
      @click="primaryAction"
    >
      <span>+</span>{{ config.cta }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
    },
  },
  methods: {
    primaryAction() {
      this.$emit('cta-action', this.config);
    },
  },
};
</script>

<style lang="scss" scoped>
.mastery-panel {
  background: #fafafa;
  border-radius: 4px;
  border-top: solid 2px #8d0098;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  padding: rem-calc(24);

  @include breakpoint(small) {
    flex-direction: column;
  }

  .content {
    width: 100%;

    .title {
      @include charter-font;
      font-size: rem-calc(14);
      margin-bottom: rem-calc(12);
    }

    .text {
      font-size: rem-calc(12);
    }
  }

  .call-to-action {
    align-items: center;
    background: transparent;
    color: #6f0079;
    cursor: pointer;
    display: flex;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    margin-left: rem-calc(40);
    min-width: 35%;

    @include breakpoint(small) {
      margin-top: rem-calc(24);
      margin-left: 0;
    }

    span {
      font-size: rem-calc(26);
      font-weight: $normal;
      margin-right: rem-calc(10);
    }
  }
}
</style>
